import React, { useEffect, useCallback } from 'react'
import PropTypes from 'helpers/proptypes'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHasLoadingSucceeded } from 'hooks'
import { Link } from 'react-router'
import { Grid, Loader, Button } from 'semantic-ui-react'
import { UserForm } from './UserForm'
import { UserCard } from 'components/cards/UserCard'
import { connectAs } from 'helpers/users'
import { fetchUser } from 'redux/entities/actions'
import { createForm, removeForm, mergeInForm } from 'redux/forms/actions'
import { getUser, fetchingUser, getUserFetchingError } from 'redux/entities/selectors'

export default function UsersIdIndex({ params: { id } }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const user = useSelector((state) => getUser(state, { id }))
  const isFetchingUser = useSelector((state) => fetchingUser(state, id))
  const fetchUserError = useSelector((state) => getUserFetchingError(state, user.id))
  const hasUserBeenFetched = useHasLoadingSucceeded(isFetchingUser, fetchUserError)

  const getUserFormPayload = useCallback((user) => {
    return {
      tags: user?.tags || [],
      phone: user?.phone || null,
      currency_id: user?.currency?.id || undefined,
      languages_ids: user?.languages?.map((l) => l?.id) || [],
      descriptions: user?.descriptions || undefined,
      payout_gateway: user?.account?.payout_gateway || undefined,
      properties: user?.properties || [],
    }
  }, [])

  useEffect(() => {
    dispatch(fetchUser(id))
  }, [dispatch, id])

  useEffect(() => {
    dispatch(createForm({ formName: 'user', initialState: getUserFormPayload() }))
    return () => dispatch(removeForm({ formName: 'user' }))
  }, [dispatch, getUserFormPayload])

  useEffect(() => {
    if (hasUserBeenFetched) dispatch(mergeInForm({ formName: 'user', value: getUserFormPayload(user) }))
  }, [dispatch, getUserFormPayload, hasUserBeenFetched, user])

  if (isFetchingUser)
    return (
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <Loader />
      </div>
    )

  if (!user) return null

  return (
    <div style={{ width: '60vw', margin: 'auto' }}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={5}>
            <UserCard user={user} connectAs={() => connectAs(user.account.id)}>
              <div style={{ textAlign: 'center' }}>
                <Button as={Link} primary basic compact to={{ pathname: `/users/${user.id}/bank-accounts` }}>
                  {t('UserCard::View payout details')}
                </Button>
              </div>
            </UserCard>
          </Grid.Column>

          <Grid.Column width={9}>
            <UserForm user={user} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

UsersIdIndex.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
}
